import { Option, SelectFilter, SelectNoContentCallable } from '@/components/Select/types';
import { KeyValue } from '@/types';
import { isObject, isEqual } from '@/utils';
import { regexWithAcents } from '@/utils/string';

export const getMappedItem = (val: Option, key: string): string => (isObject(val) ? (val as KeyValue)[key] : val);

export const replaceSelectSearch = (value: string | number, search: RegExp) =>
  value
    .toString()
    .replace(search, '<span>$1</span>')
    .replace(/(<\/?span>)\s/g, '$1&nbsp')
    .replace(/\s(<\/?span>)/g, '&nbsp$1');

export const makeSelectSearch = (value: string) => {
  let strToRegex = `${value}`;
  const incrementalSearch = value
    .split(' ')
    .filter((item) => item.trim().length > 2)
    .filter((_, index) => index < 2);

  if (incrementalSearch.length > 1) strToRegex = [strToRegex, ...incrementalSearch].join('|');

  return regexWithAcents(strToRegex);
};

export const makeDefaultFilter = (optionLabel: string) => {
  const filter: SelectFilter = (value, options) => {
    if (!value) return [...(options || [])];
    const search = makeSelectSearch(value);
    const result = options.filter((item) => getMappedItem(item, optionLabel).toString().search(search) >= 0);
    return result;
  };

  return filter;
};

export const defaultNoContentMsg = {
  empty: 'Sem itens disponíveis no momento.',
  notFound: 'Sua busca não encontrou resultados.',
  onLoad: 'Buscando dados...',
};

export const notContentFunction: SelectNoContentCallable = (buffer, processing, { empty, notFound, onLoad }) => {
  if (processing) return onLoad;
  return !buffer.length ? empty : notFound;
};

export const getCurrentIndex = (options: Option[], value: Option, option: string) => {
  if (!options.length || value === undefined) return -1;

  const realValue = getMappedItem(value, option);

  return options.findIndex((item) => isEqual(realValue, getMappedItem(item, option)));
};
